<template>
  <div>
    <SubTitle text="Datos generales"/>
    <div class="card-section">
      <el-row :gutter="18">
        <el-form>
          <el-col>
            <el-form-item label="Modo de planificación">
              <el-radio-group v-model="alg_settings.simpli_mode" size="mini">
                <el-radio-button :label="false">Geosort</el-radio-button>
                <el-radio-button :label="true">SimpliRoute</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="CT / CTT">
              <el-select  v-model="ct"
                          value-key="select_key"
                          size="mini"
                          filterable
                          placeholder="Ej: Local Internet">
                <el-option  v-for="ct in ctsAndCtts"
                            :key="ct.select_key"
                            :label="ct.name"
                            :value="ct">
                  <img :src="require(`@/assets/img/bus/${getBuImageName(ct.bu)}.svg`)"
                       class="label-img-ct">
                  {{ct.name}}
                  <span class="label-id-ct"> · {{ct.id}}</span>
                  <span class="label-facility-ct">{{ct.facility}}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="Tipo de viaje">
              <el-select  v-model="travelType"
                          value-key="id"
                          size="mini"
                          filterable
                          placeholder="Ej: F11">
                <el-option  v-for="travelType in travelTypes"
                            :key="travelType.id"
                            :label="travelType.name"
                            :value="travelType"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="Fecha">
              <div class="datePicker">
                <el-date-picker v-model="date"
                                size="mini"
                                :clearable="false"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Fecha"
                                :picker-options="pickerOptions">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="Inicio">
              <el-time-picker format="HH:mm"
                              size="mini"
                              :clearable="false"
                              value-format="HH:mm"
                              v-model="timeInit"
                              placeholder="09:00">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="Término">
              <el-time-picker format="HH:mm"
                              size="mini"
                              :clearable="false"
                              value-format="HH:mm"
                              v-model="timeFinish"
                              placeholder="12:00">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col v-show="alg_settings.simpli_mode">
            <el-divider/>
            <el-row :gutter="18">
              <el-col :sm="12">
                <el-form-item label="Balanceo">
                  <el-radio-group v-model="alg_settings.balance" size="mini">
                    <el-radio-button :label="true">Sí</el-radio-button>
                    <el-radio-button :label="false">No</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item label="Todos los vehículos">
                  <el-radio-group v-model="alg_settings.all_vehicles" size="mini">
                    <el-radio-button :label="true">Sí</el-radio-button>
                    <el-radio-button :label="false">No</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item label="Vuelta al CD">
                  <el-radio-group v-model="alg_settings.back_to_cd" size="mini">
                    <el-radio-button :label="true">Sí</el-radio-button>
                    <el-radio-button :label="false">No</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item label="Multiviaje">
                  <el-radio-group v-model="alg_settings.multi_trip" size="mini">
                    <el-radio-button :label="true">Sí</el-radio-button>
                    <el-radio-button :label="false">No</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item label="Ventana horaria suave">
                  <el-radio-group v-model="alg_settings.enable_soft_window" size="mini">
                    <el-radio-button :label="true">Sí</el-radio-button>
                    <el-radio-button :label="false">No</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="Factor de tráfico">
                  <el-radio-group v-model="alg_settings.traffic_factor"
                                  size="mini"
                                  class="radio-tf">
                    <el-radio-button v-for="(tf, index) in trafficFactors"
                                     :key="index"
                                     :label="tf">
                      {{tf.toPrecision(2)}}
                    </el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="SimpliFy">
                  <div class="simpli-alg">
                    <el-radio-group v-model="alg_settings.simplify" size="mini">
                      <el-radio-button :label="true">Sí</el-radio-button>
                      <el-radio-button :label="false">No</el-radio-button>
                    </el-radio-group>
                    <el-slider v-model="alg_settings.fmb"
                               :disabled="!alg_settings.simplify"
                               :min="1"
                               :max="5"/>
                  </div>
                </el-form-item>
              </el-col>
              <el-col>
                <el-collapse class="info-simpli">
                  <el-collapse-item>
                    <template slot="title">
                      <span class="info-simpli-title">
                        <i class="fas fa-info-circle"/>
                        ¿Qué significa cada variable en SimpliRoute?
                      </span>
                    </template>
                    <el-row :gutter="18" class="info-simpli-content">
                      <el-col>
                        <span class="info-simpli-description">
                          <span>Balanceo:</span>
                          Al optimizar se usarán todos los vehículos y se les asignará una cantidad
                          equilibrada de visitas.
                        </span>
                        <span class="info-simpli-description">
                          <span>Vuelta al CD:</span>
                          Las rutas propuestas terminarán en el último punto de entrega, sin
                          considerar la vuelta de los vehículos a la bodega.
                        </span>
                        <span class="info-simpli-description">
                          <span>MultiViaje:</span>
                          Una de las propuestas de rutas puede considerar más de una salida por
                          vehículo. Al activar esta opción indicarás a la plataforma que deseas
                          programar una sola salida por optimización.
                        </span>
                        <span class="info-simpli-description">
                          <span>Factor de tráfico:</span>
                          Permite configurar la velocidad de desplazamiento entre las visitas que se
                          tiene en cuenta a la hora de crear rutas. Ajustala solo si consideras que
                          los tiempos de traslado calculados no se ajustan a tu flota.
                        </span>
                        <span class="info-simpli-description">
                          <span>Todos los vehículos:</span>
                          Se usará la menor cantidad de vehículos posible para atender las visitas
                          ingresadas a plataforma.
                        </span>
                        <span class="info-simpli-description">
                          <span>Ventana horaria suave:</span>
                          Se podrá romper las ventanas horarias de las visitas para lograr incluir
                          más visitas en las rutas.
                        </span>
                        <span class="info-simpli-description">
                          <span>Simplify:</span>
                          Algoritmo que entrega respuestas más zonificadas.
                        </span>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
              </el-col>
            </el-row>
          </el-col>
        </el-form>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SubTitle from '../../base/SubTitle.vue';
import { cachedAPIRequest } from '../../../../mixins/cacheDim';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  name: 'ExtraData',
  components: {
    SubTitle,
  },
  data() {
    return {
      ct: {},
      cts: [],
      ctts: [],
      trafficFactors: [1.0, 1.5, 2.0, 3.0],
      alg_settings: {
        simpli_mode: true,
        balance: true,
        all_vehicles: true,
        back_to_cd: false,
        multi_trip: false,
        euclidian_distance: true,
        traffic_factor: 1.5,
        simplify: false,
        fmb: 1,
        enable_soft_window: false,
      },
      travelType: {},
      travelTypes: [],
      timeInit: '09:00',
      timeFinish: '21:00',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(Date.now() - 86400000);
        },
      },
      date: moment(new Date(Date.now())).format('YYYY-MM-DD'),
    };
  },
  mounted() {
    this.getCts();
    this.getCtts();
    this.sendData();
    this.getTravelTypes();
  },
  watch: {
    value: {
      handler() {
        this.syncCt(this.value.ct);
        if (this.value.alg_settings) this.alg_settings = this.value.alg_settings;
        this.travelType = this.value.travel_type;
        this.timeInit = moment(this.value.time_init).format('HH:mm');
        // this.date = moment(this.value.time_init).format('YYYY-MM-DD');
        this.timeFinish = moment(this.value.time_finish).format('HH:mm');
      },
      deep: true,
    },
    ct() {
      this.sendData();
    },
    alg_settings: {
      handler() {
        this.sendData();
      },
      deep: true,
    },
    travelType() {
      this.sendData();
    },
    timeInit() {
      if (this.timeInit === null) this.timeInit = '09:00';
      this.sendData();
    },
    timeFinish() {
      if (this.timeFinish === null) this.timeInit = '09:00';
      this.sendData();
    },
    date() {
      if (this.date === null) this.date = moment(new Date(Date.now())).format('YYYY-MM-DD');
      this.sendData();
    },
  },
  methods: {
    sendData() {
      this.$emit('input', this.getData());
      this.$emit('errors', this.getErrors());
    },
    getCtSelectKey(ct) {
      const facility = ct && ct.is_ctt ? 'ctt' : 'ct';
      const id = ct && ct.id ? ct.id : '';
      const name = ct && ct.name ? ct.name : '';
      return `${facility}-${id}-${name}`;
    },
    normalizeCt(ct) {
      if (!ct || !ct.id) return {};
      return {
        ...ct,
        select_key: ct.select_key || this.getCtSelectKey(ct),
      };
    },
    resolveCt(ct) {
      if (!ct || !ct.id) return {};
      const normalizedCt = this.normalizeCt(ct);
      const match = this.ctsAndCtts.find(option => option.select_key === normalizedCt.select_key);
      return match || normalizedCt;
    },
    syncCt(ct) {
      const nextCt = this.resolveCt(ct);
      const currentKey = this.ct && this.ct.select_key ? this.ct.select_key : '';
      const nextKey = nextCt && nextCt.select_key ? nextCt.select_key : '';

      if (currentKey !== nextKey) {
        this.ct = nextCt;
      }
    },
    getData() {
      return {
        ct: this.normalizeCt(this.ct),
        alg_settings: this.alg_settings,
        time_init: this.getTimeInit,
        travel_type: this.travelType,
        time_finish: this.getTimeFinish,
      };
    },
    getErrors() {
      const err = [];
      if (this.date === null) err.push('Fecha incorrecta');
      if (this.timeInit === null) err.push('Hora de inicio incorrecta');
      if (this.timeFinish === null) err.push('Hora de termino incorrecta');
      if (!this.travelType.id) err.push('Seleccione un tipo de viaje');
      if (!this.ct.id) err.push('Seleccione un centro de distribución');
      return err;
    },
    getCts() {
      cachedAPIRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((response) => {
        this.cts = response.data.map(ct => ({
          id: ct.id,
          name: ct.name,
          is_ctt: false,
          select_key: this.getCtSelectKey(ct),
          facility: ct.facility,
          bu: ct.business_unit ? ct.business_unit.name : '',
        }));
        this.syncCt(this.ct);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los ct',
        });
      });
    },
    getCtts() {
      cachedAPIRequest({
        module: 'planning',
        service: 'transfer_center',
        params: { limit: 1000 },
      }).then((response) => {
        this.ctts = response.data.map(ct => ({
          id: ct.id,
          name: ct.name,
          is_ctt: true,
          select_key: this.getCtSelectKey({ ...ct, is_ctt: true }),
          facility: 'ctt',
          bu: ct.business_unit ? ct.business_unit.name : '',
        }));
        this.syncCt(this.ct);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los ct',
        });
      });
    },
    getTravelTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'travel_types',
        params: { limit: 1000 },
      }).then((response) => {
        this.travelTypes = response.data
          .map(travelType => ({ id: travelType.id, name: travelType.type }))
          .sort((a, b) => (b.name > a.name ? -1 : 1));
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los tipos de viaje',
        });
      });
    },
    getBuImageName(bu) {
      let buName = 'generic';
      if (bu === 'FCOM') {
        buName = 'fcom';
      } else if (bu === 'Sodimac') {
        buName = 'sodimac';
      } else if (bu === 'Falabella') {
        buName = 'falabella';
      }
      return buName;
    },
  },
  computed: {
    getTimeInit() {
      return this.date && this.timeInit
        ? moment(`${this.date}T${this.timeInit}`).toISOString() : null;
    },
    getTimeFinish() {
      return this.date && this.timeFinish
        ? moment(`${this.date}T${this.timeFinish}`).toISOString() : null;
    },
    ctsAndCtts() {
      return this.cts.concat(this.ctts).sort((a, b) => (b.name > a.name ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-section {
    border-radius: 3px;
    border: 1px solid #E0E0E0;
    padding: 20px 16px 0;
    .el-form-item { margin-bottom: 12px; }
    .el-divider { margin: 0 0 15px 0; }
    .el-form-item__content > .el-slider { padding-top: 10px; }
    .simpli-alg {
      width: 100%;
      padding-top: 8px;
      display: inline-block;
      .el-radio-group {
        width: 105px;
        float: left;
      }
      .el-slider {
        float: right;
        margin-top: -4px;
        width: calc(100% - 105px);
      }
    }
  }
  .label-id-ct { color: $fb-grey-light-70; }
  .label-facility-ct {
    height: 18px;
    padding: 0 8px;
    margin: 8px 0;
    line-height: 1.3;
    float: right;
    color: $fb-grey-light-50;
    background-color: $fb-grey-light-94;
    border-radius: 2px;
    font-size: 12px;
    letter-spacing: 0.4px;
  }
  .label-img-ct {
    height: 20px;
    display: block;
    float: left;
    margin: 7px 7px 0 0;
  }
  .info-simpli {
    .el-collapse-item__content {
      padding-bottom: 8px !important;
    }
    .info-simpli-title {
      color: #666;
      i {
        font-size: 20px;
        color: $fb-amber;
        margin-right: 4px;
        vertical-align: middle;
      }
    }
    .info-simpli-content {
      text-align: justify;
      line-height: 1.1;
      color: $fb-grey-light-50;
      .info-simpli-description {
        display: block;
        margin-bottom: 8px;
        span { font-weight: 800; }
      }
    }
  }
</style>
